import React from "react";

import "./Loading.scss";

export const LoadingBar = ({ bgcolor, completed }) => {
  return (
    <div className="loading-bar">
      <div className="loading-bar__filler">
        {/* <span style={labelStyles}>{`${completed}%`}</span> */}
      </div>
    </div>
  );
};
